import { ImportHistoryApi } from '../../../../api/importHistoryApi';
import { BatchDeterminationContext } from '../../../../contexts/BatchDeterminationContext';
import { IMPORT_PROCESS_STATE } from '../../../../shared/constants/ImportPageConstants';
import { EMPTY_STRING } from '../../../../shared/constants/constants';
import './ProcessingImport.scss';
import { SovosCircularProgress } from 'mosaic-react';
import { Dispatch, SetStateAction, useCallback, useContext, useEffect, useState } from 'react';

interface ProcessingImportProps {
	processId: string;
	setProcessStatus: Dispatch<SetStateAction<number>>;
	isAudit: boolean;
}

const ProcessingImport = (props: ProcessingImportProps) => {
	const { processId, setProcessStatus, isAudit } = props;
	const [completedLines, setCompletedLines] = useState<number>(0);
	const [linesLoaded, setLinesLoaded] = useState<boolean>(false);
	const { getImportData } = useContext(BatchDeterminationContext);

	const getProcessStatus = useCallback(() => {
		if (processId && processId !== EMPTY_STRING) {
			ImportHistoryApi.getProcessStatusByProcessId(processId)
				.then(statusResponse => {
					const data = statusResponse.data;
					if (data) {
						setCompletedLines(data.lines);
						setLinesLoaded(true);
					}
					if (data.status !== 'PROCESSING' && data.status !== 'NEW') {
						setProcessStatus((IMPORT_PROCESS_STATE as any)[data.status]);
						getImportData();
					}
				})
				.catch(() => {
					setProcessStatus(IMPORT_PROCESS_STATE.ERROR);
				});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [processId, setProcessStatus]);

	useEffect(() => {
		getProcessStatus();
		const interval = setInterval(() => {
			getProcessStatus();
		}, 3000);
		return () => clearInterval(interval);
	}, [processId, setProcessStatus, getProcessStatus]);

	return (
		<div className='centered' style={{ marginTop: '20%' }}>
			<div className='centered'>
				<SovosCircularProgress />
				<h4 style={{ marginLeft: 20 }}>
					{isAudit ? (
						'Saving data...'
					) : (
						<>
							{linesLoaded
								? `${completedLines ? completedLines.toLocaleString() : 0} ${
										completedLines && completedLines > 1 ? 'transactions' : 'transaction'
								  } uploading...`
								: 'Getting status...'}
						</>
					)}
				</h4>
			</div>
			<div className='centered message'>
				<span>While your file is {isAudit ? 'saving' : 'uploading'}, you can leave this page. </span>
				<span>
					You'll see the status {isAudit ? '"Saved"' : '"Uploaded"'} on the Uploads page next to the file when the
					{isAudit ? ' the data has been saved.' : ' upload is ready.'}
				</span>
			</div>
		</div>
	);
};

export default ProcessingImport;
